import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from '../select';
import './homeMap.scss';
import { PlacesProvider } from '../../dataProvider/places';
import SvgMap from '../maps/index';
import CustomMap from './customMap';
import Card from '../card/index';

export const HomeMap = ({
  firstSelectList,
  firstLevelSelectedItem,
  onFirstSelectChange,
  secondSelectList,
  onSecondSelectChange,
  mapData,
  onMapSelectionChange
}) => {
  const [firstLevelSelected, changeFirstLevelSelected] = useState(
    firstLevelSelectedItem
  );
  const firstLevelChange = e => {
    changeFirstLevelSelected(e);
  };

  return (
    <div className="HomeMap">
      <div className="grid-row">
        <div className="selectsContainer">
          <PlacesProvider type="PROVINCE">
            {data => {
              return (
                <Select
                  placeholder="Seleccione provincia"
                  items={data}
                  selected={firstLevelSelected}
                  valueKey="ineId"
                  onChangeSelection={firstLevelChange}
                />
              );
            }}
          </PlacesProvider>
          <PlacesProvider type="TOWN" parent size="2500">
            {data => {
              return (
                <Select
                  items={data || []}
                  placeholder="Seleccione municipio"
                  valueKey="ineId"
                />
              );
            }}
          </PlacesProvider>
        </div>
        <PlacesProvider type="PROVINCE">
          {data => {
            return <CustomMap maps={data} />;
          }}
        </PlacesProvider>
        <div>
          <Card
            title="ESCRUTADO:"
            titleValue="75%"
            subtitle="Actualizado a las: 22:35"
          >
            {/* <AtresPieChart {...chartData} /> */}
          </Card>
        </div>
      </div>
      <div className="grid-row" />
    </div>
  );
};

HomeMap.propTypes = {
  firstLevelSelectedItem: PropTypes.string,
  firstSelectList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      parent: PropTypes.string
    })
  ).isRequired,
  onFirstSelectChange: PropTypes.func.isRequired,
  secondSelectList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      parent: PropTypes.string
    })
  ),
  onSecondSelectChange: PropTypes.func.isRequired,
  mapData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      svg: PropTypes.string,
      winner: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      parent: PropTypes.string
    })
  ).isRequired,
  onMapSelectionChange: PropTypes.func.isRequired
};

HomeMap.defaultProps = {
  secondSelectList: [],
  firstLevelSelectedItem: ''
};

export default HomeMap;
